/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleDate from 'base/components/standalone/ArticleDate';

export const DynamicStandaloneArticleDate = StandaloneArticleDate;
export type DynamicStandaloneArticleDateProps = PropsFromComponent<typeof StandaloneArticleDate>;

export const DynamicStandaloneArticleDateWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleDate => {
    return function DynamicStandaloneArticleDate(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleDate');
        return <StandaloneArticleDate {...mergeProps({ options: { theme } }, props)} />;
    }
}